import { Operation } from "@apollo/client"

export const shouldRetryRequest = async (
  count: number,
  operation: Operation,
  error: any
) => {
  const { appState } = operation.getContext()
  const statusCode =
    error?.statusCode ??
    error?.status ??
    error?.response?.status ??
    error?.networkError?.statusCode ??
    error?.networkError?.response?.status ??
    0
  const operationDefinition = operation.query.definitions.find(
    definition => definition.kind === "OperationDefinition"
  )
  const isQuery =
    operationDefinition?.kind === "OperationDefinition" &&
    operationDefinition.operation === "query"
  return appState?.online === true && isQuery && statusCode === 0 && count <= 4
}
